<template lang="pug">
v-app.sumut
  f-drawer(v-model="drawer")
  v-main.content-background
    f-toolbar
    f-dialog-timeout(v-model="dialog", :username="username")
    f-dialog-first-login(v-model="dialogFirstLogin", :username="username")
    f-dialog-change-password(v-model="dialogPass", :username="username")
    v-dialog(v-model="progress", persistent, width="400")
      v-card
        v-card-title.title Harap Tunggu
        v-card-text
          v-progress-linear(v-if="progress", :indeterminate="true")
    v-container(fluid)
      v-snackbar(
        :color="alertType(alert.alertType)",
        v-model="alert.alertId",
        :multi-line="true",
        :right="true",
        :timeout="5000",
        :top="true",
        text
      ) 
        v-row
          v-icon.mx-2(:color="alert.alertType", large) {{ alert.icon }}
          .ma-4 {{ alert.body }}
      router-view
</template>
<script>
import EventBus from "../../../service/event-bus.service";
import _debounce from "lodash/debounce";
export default {
  name: "FMainMenuSumut",
  data() {
    return {
      dialog: false,
      dialogPass: false,
      dialogFirstLogin: false,
      drawer: true,
      username: "",
    };
  },
  computed: {
    alert() {
      return this.$store.state.alert;
    },
    progress() {
      return this.$store.state.progress;
    },
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
  },
  watch: {
    isIdle(val) {
      if (val) {
        this.dialog = true;
      }
    },
  },
  mounted() {
    this.$session.userDetail().then((item) => {
      this.username = item.username || "";
      if (item.user.firstLogin) {
        this.dialogFirstLogin = true;
      }
      if (item.user.needChangePassword) {
        this.dialogPass = true;
      }
    });
    this.alert.alertId = false;
    this.$router.push({ name: "dashboard" }).catch((err) => {});
  },
  created() {
    let notif = _debounce(
      () => {
        if (!this.notif) {
          this.dialog = true;
        }
      },
      10000,
      { leading: true, trailing: false }
    );

    EventBus.$on("unauthorized-access", notif);
  },
  methods: {
    close() {
      this.alert.alertId = false;
    },
    alertType(type) {
      return type;
    },
  },
};
</script>
<style src="../../../assets/style/sumut/menu-sumut.css"/>